import React from 'react';
import './LegalScreen.css';

// Public page — Privacy Policy + Terms. Accessible without logging in.
// NOTE: these are solid starting drafts tailored to Morocco (law 09-08 / CNDP).
// Have a lawyer review before charging customers.
function LegalScreen() {
  return (
    <div className="legal">
      <div className="legal-inner">
        <a href="/" className="legal-back">← StratosPOS</a>

        <div className="legal-warn">
          ⚖️ Modèle de référence à faire valider par un juriste avant utilisation
          commerciale. / Template — have a lawyer review before commercial use.
        </div>

        <h1 id="privacy">Politique de confidentialité</h1>
        <p className="legal-date">Dernière mise à jour : 2026</p>

        <h2>1. Qui sommes-nous</h2>
        <p>
          StratosPOS est un logiciel de point de vente (caisse) destiné aux cafés,
          restaurants et commerces. Le présent document explique quelles données
          nous traitons et comment. Pour toute question : <b>[votre email / téléphone]</b>.
        </p>

        <h2>2. Données que nous traitons</h2>
        <ul>
          <li><b>Compte :</b> votre email, votre nom, et votre mot de passe (stocké
            chiffré, jamais en clair).</li>
          <li><b>Données du commerce :</b> vos produits, prix, stocks, commandes et
            statistiques.</li>
          <li><b>Clients « carnet » :</b> si vous utilisez le carnet, le nom et
            éventuellement le téléphone de vos clients réguliers, ainsi que leur solde.
            Ces données sont saisies par vous, sous votre responsabilité.</li>
        </ul>

        <h2>3. Pourquoi nous les traitons</h2>
        <p>
          Uniquement pour fournir le service : enregistrer vos ventes, gérer votre
          menu et votre stock, produire vos statistiques et gérer les abonnements.
          Nous ne vendons jamais vos données et ne les utilisons pas à des fins
          publicitaires.
        </p>

        <h2>4. Où et comment elles sont stockées</h2>
        <p>
          Les données sont hébergées chez notre prestataire d'infrastructure
          (Supabase) sur des serveurs sécurisés, transmises de façon chiffrée
          (HTTPS). Chaque commerce est <b>isolé</b> au niveau de la base de données :
          un commerce ne peut jamais voir les données d'un autre.
        </p>

        <h2>5. Qui peut voir vos données</h2>
        <p>
          Seuls vous et les membres de votre équipe que vous avez autorisés, selon
          leur rôle. Nous (l'éditeur) pouvons accéder aux données uniquement pour
          l'assistance technique ou une obligation légale.
        </p>

        <h2>6. Durée de conservation</h2>
        <p>
          Vos données sont conservées tant que votre compte est actif. Après
          résiliation, elles peuvent être supprimées sur simple demande.
        </p>

        <h2>7. Vos droits</h2>
        <p>
          Conformément à la loi marocaine <b>n° 09-08</b> relative à la protection des
          personnes physiques à l'égard du traitement des données à caractère
          personnel (supervisée par la <b>CNDP</b>), vous disposez d'un droit
          d'accès, de rectification, d'opposition et de suppression. Vous pouvez
          <b> exporter toutes vos données</b> à tout moment depuis Réglages →
          Données &amp; sauvegarde. Pour exercer vos droits : <b>[votre contact]</b>.
        </p>

        <h2>8. Déclaration CNDP</h2>
        <p>
          Le traitement de données personnelles au Maroc peut nécessiter une
          déclaration auprès de la CNDP. L'exploitant de StratosPOS s'engage à
          effectuer les démarches nécessaires. (Note à l'éditeur : effectuer la
          déclaration avant la commercialisation.)
        </p>

        <h2>9. Sécurité</h2>
        <p>
          Mots de passe chiffrés, connexions chiffrées (HTTPS), isolation stricte
          des données par commerce (Row Level Security), et contrôle d'accès par
          rôle. Aucun système n'est parfait à 100 %, mais nous appliquons les
          bonnes pratiques du secteur.
        </p>

        <hr />

        <h1 id="terms">Conditions d'utilisation</h1>
        <p className="legal-date">Dernière mise à jour : 2026</p>

        <h2>1. Le service</h2>
        <p>
          StratosPOS fournit un logiciel de caisse accessible via un navigateur ou
          installé sur l'appareil. Le service est fourni « en l'état », avec des
          améliorations continues.
        </p>

        <h2>2. Abonnement et paiement</h2>
        <p>
          L'accès est proposé par abonnement mensuel (formules Basic, Pro, Max). Le
          paiement s'effectue selon les modalités convenues avec l'éditeur. À
          l'expiration de l'abonnement, l'accès est suspendu ; <b>vos données ne sont
          pas supprimées</b> et restent récupérables en régularisant.
        </p>

        <h2>3. Essai gratuit</h2>
        <p>
          Un nouvel établissement bénéficie d'une période d'essai gratuite. Aucun
          paiement n'est requis pendant l'essai.
        </p>

        <h2>4. Usage acceptable</h2>
        <p>
          Vous vous engagez à utiliser le service de manière licite, à ne pas tenter
          d'y accéder de façon non autorisée, et à être responsable des données que
          vous saisissez (notamment les données de vos clients « carnet »).
        </p>

        <h2>5. Propriété des données</h2>
        <p>
          <b>Vos données vous appartiennent.</b> Vous pouvez les exporter à tout
          moment. Nous n'en revendiquons aucune propriété.
        </p>

        <h2>6. Disponibilité et responsabilité</h2>
        <p>
          Nous nous efforçons d'assurer une disponibilité maximale mais ne
          garantissons pas un service sans interruption. Dans les limites permises
          par la loi, notre responsabilité est limitée au montant de l'abonnement
          des derniers mois.
        </p>

        <h2>7. Résiliation</h2>
        <p>
          Vous pouvez cesser d'utiliser le service à tout moment. Nous pouvons
          suspendre un compte en cas de non-paiement ou d'usage abusif.
        </p>

        <h2>8. Droit applicable</h2>
        <p>
          Les présentes conditions sont régies par le droit marocain. Tout litige
          relève des tribunaux compétents du Maroc.
        </p>

        <h2>9. Contact</h2>
        <p><b>[Nom de l'exploitant] — [email] — [téléphone]</b></p>

        <a href="/" className="legal-back legal-back-bottom">← Retour à StratosPOS</a>
      </div>
    </div>
  );
}

export default LegalScreen;
